import { useState } from "react";
import styled from "styled-components";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import font from "src/styles/font";
import device from "src/styles/device";
import { White01 } from "src/styles/color";

import TextField from "src/components/core/TextField";

const WrapperContainer = styled.div`
  width: 100%;
`;

const WrapperBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;

  /* disabled */
  .MuiInputBase-root.Mui-disabled {
    background-color: ${White01};
  }

  /* @media ${device.mobileL} {
    gap: 4px;

    .MuiFormControl-root {
      width: 100%;
      min-width: unset;
      max-width: unset;
    }
  } */
`;

const SpanLabel = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  line-height: 24px;

  @media ${device.mobileL} {
    font-size: ${font.size.sm};
  }
`;

const StyledRadioGroup = styled(RadioGroup)`
  .MuiFormControlLabel-label {
    width: 100%;
    font-size: ${font.size.md};
    font-weight: 400;
    line-height: 24px;
  }
`;

const CancelMessage = ({ updateOrder, setUpdateOrder }) => {
  const cancelMessages = [
    "สินค้าไม่พร้อมส่ง",
    "ลูกค้าขอให้ยกเลิกรายการ",
    "ติดต่อลูกค้าไม่ได้",
    "ร้านค้าใช้เวลาเตรียมสินค้านานเกินไป",
    "ร้านค้าไม่ตอบกลับ",
    "ค่าส่งแพงเกินไป",
    "เปลี่ยนใจ",
    "ทำรายการผิดพลาด",
    "อื่นๆ",
  ];

  const [isOtherReason, setIsOtherReason] = useState(false);
  const [isOtherFocused, setIsOtherFocused] = useState(false);

  const handleSelectReason = (event) => {
    if (event.target.value === "อื่นๆ") {
      setIsOtherReason(true);
      setUpdateOrder({
        ...updateOrder,
        cancelMessage: "",
      });
    } else {
      setIsOtherReason(false);
      setUpdateOrder({
        ...updateOrder,
        cancelMessage: event.target.value,
      });
    }
  };

  return (
    <WrapperContainer>
      <FormControl sx={{ width: "100%" }}>
        <StyledRadioGroup
          aria-labelledby="cancel-reason-radio-buttons-group-label"
          name="cancel-reason-radio-buttons-group"
          value={updateOrder?.cancelMessage}
          onChange={handleSelectReason}
        >
          {cancelMessages.map((option) => (
            <FormControlLabel
              value={option}
              control={
                <Radio
                  checked={
                    option === "อื่นๆ"
                      ? isOtherReason
                      : updateOrder?.cancelMessage === option
                  }
                  sx={{
                    color: "#e04132",
                    "&.Mui-checked": {
                      color: "#e04132",
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: 22,
                    },
                  }}
                />
              }
              // componentsProps={{ typography: { variant: "body1" } }}
              label={
                <>
                  {option === "อื่นๆ" ? (
                    <WrapperBox>
                      <SpanLabel>{option}</SpanLabel>

                      <TextField
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                          setUpdateOrder({
                            ...updateOrder,
                            cancelMessage: e.target.value,
                          });
                        }}
                        onFocus={() => setIsOtherFocused(true)}
                        onBlur={() => setIsOtherFocused(false)}
                        value={isOtherReason ? updateOrder.cancelMessage : ""}
                        disabled={!isOtherReason}
                        inputProps={{
                          sx: {
                            padding: {
                              sm: "12px 16px",
                              xs: "8px 12px",
                            },
                          },
                        }}
                        sx={{
                          maxWidth: {
                            sm: isOtherFocused ? 'unset' : 200,
                            xs: "unset",
                          },
                        }}
                      />
                    </WrapperBox>
                  ) : (
                    <SpanLabel>{option}</SpanLabel>
                  )}
                </>
              }
              // label={option}
            />
          ))}
        </StyledRadioGroup>
      </FormControl>
    </WrapperContainer>
  );
};

export default CancelMessage;
